<template>
    <div class="loading"></div>

    <nav-bar/>
    <aside-menu :menu="menu"/>
    <hero-bar>
        <slot name="header"/>
    </hero-bar>

    <main-section>
        <slot/>
    </main-section>

    <footer-bar/>
</template>

<script>
import menu from '@/menu.js'
import NavBar from '@/Components/Dashboard/NavBar'
import AsideMenu from '@/Components/Dashboard/AsideMenu'
import HeroBar from '@/Components/Dashboard/HeroBar'
import MainSection from '@/Components/Dashboard/MainSection'
import FooterBar from '@/Components/Dashboard/FooterBar'

export default {
    name: 'Dashboard',
    components: {
        AsideMenu,
        NavBar,
        HeroBar,
        MainSection,
        FooterBar
    },
    mounted() {
        document.body.classList.add('dashboard');
    },
    unmounted() {
        document.body.classList.remove('dashboard');
    },
    setup() {
        return {
            menu
        }
    }
}
</script>
